import React, { useState, useEffect } from 'react';
import { Users, Smartphone, MessageCircle } from 'lucide-react';
import ListaUsuariosAplicativo from './ListaUsuariosAplicativo';
import ListaUsuariosWhatsapp from './ListaUsuariosWhatsapp';
import supabase from '../../../config/supabaseClient';

const DashboardPopulacao = () => {
  const [abaAtiva, setAbaAtiva] = useState('aplicativo');
  const [estatisticas, setEstatisticas] = useState({
    usuariosAplicativo: 0,
    usuariosWhatsapp: 0,
    usuariosAplicativoAtivos: 0,
    usuariosAplicativoInativos: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    carregarEstatisticas();
  }, []);

  const carregarEstatisticas = async () => {
    try {
      setLoading(true);

      // Carregar estatísticas dos usuários do aplicativo
      const { data: usuariosApp, error: errorApp } = await supabase
        .from('usuario')
        .select('id, ativo');

      if (errorApp) throw errorApp;

      // Carregar estatísticas dos usuários do WhatsApp
      const { data: usuariosWhats, error: errorWhats } = await supabase
        .from('usuario_whatsapp')
        .select('id');

      if (errorWhats) throw errorWhats;

      const usuariosAplicativo = usuariosApp?.length || 0;
      const usuariosWhatsapp = usuariosWhats?.length || 0;
      const usuariosAplicativoAtivos = usuariosApp?.filter(u => u.ativo).length || 0;
      const usuariosAplicativoInativos = usuariosAplicativo - usuariosAplicativoAtivos;

      setEstatisticas({
        usuariosAplicativo,
        usuariosWhatsapp,
        usuariosAplicativoAtivos,
        usuariosAplicativoInativos
      });
    } catch (error) {
      console.error('Erro ao carregar estatísticas:', error);
    } finally {
      setLoading(false);
    }
  };

  const renderConteudo = () => {
    switch (abaAtiva) {
      case 'aplicativo':
        return <ListaUsuariosAplicativo />;
      case 'whatsapp':
        return <ListaUsuariosWhatsapp />;
      default:
        return <ListaUsuariosAplicativo />;
    }
  };

  return (
    <div className="gestao-usuarios dashboard-full-container">
      <div className="dashboard-header">
        <div className="header-content">
          <h1>
            <Users size={32} />
            População de Usuários
          </h1>
          <p>Usuários do aplicativo móvel e WhatsApp</p>
        </div>
      </div>

      {/* Cards de Estatísticas */}
      {!loading && (
        <div className="stats-grid">
          <div className="stat-card total">
            <div className="stat-icon">
              <Smartphone size={24} />
            </div>
            <div className="stat-content">
              <h3>Usuários do Aplicativo</h3>
              <div className="stat-number">{estatisticas.usuariosAplicativo}</div>
              <div className="stat-label">usuários cadastrados</div>
            </div>
          </div>

          <div className="stat-card ativo">
            <div className="stat-icon">
              <Users size={24} />
            </div>
            <div className="stat-content">
              <h3>Aplicativo - Ativos</h3>
              <div className="stat-number">{estatisticas.usuariosAplicativoAtivos}</div>
              <div className="stat-label">usuários ativos</div>
            </div>
          </div>

          <div className="stat-card inativo">
            <div className="stat-icon">
              <Users size={24} />
            </div>
            <div className="stat-content">
              <h3>Aplicativo - Inativos</h3>
              <div className="stat-number">{estatisticas.usuariosAplicativoInativos}</div>
              <div className="stat-label">usuários inativos</div>
            </div>
          </div>

          <div className="stat-card whatsapp">
            <div className="stat-icon">
              <MessageCircle size={24} />
            </div>
            <div className="stat-content">
              <h3>Usuários do WhatsApp</h3>
              <div className="stat-number">{estatisticas.usuariosWhatsapp}</div>
              <div className="stat-label">contatos registrados</div>
            </div>
          </div>
        </div>
      )}

      {/* Abas de Navegação */}
      <div className="tabs-container">
        <div className="tabs-header">
          <button
            className={`tab-button ${abaAtiva === 'aplicativo' ? 'active' : ''}`}
            onClick={() => setAbaAtiva('aplicativo')}
          >
            <Smartphone size={20} />
            Usuários do Aplicativo
            <span className="tab-count">{estatisticas.usuariosAplicativo}</span>
          </button>
          <button
            className={`tab-button ${abaAtiva === 'whatsapp' ? 'active' : ''}`}
            onClick={() => setAbaAtiva('whatsapp')}
          >
            <MessageCircle size={20} />
            Usuários do WhatsApp
            <span className="tab-count">{estatisticas.usuariosWhatsapp}</span>
          </button>
        </div>

        <div className="tab-content">
          {renderConteudo()}
        </div>
      </div>
    </div>
  );
};

export default DashboardPopulacao;